const SEARCH = require('./search-constants');
const BOOKINGS = require('./bookings-constants');

module.exports = {
    MAIN_BUSINESS_LINE: {
        CORPORATIONS_DIRECT_INCLUDE_LEISURE: 'corporation_direct_include_leisure',
        CORPORATION_THROUGH_TMC: 'corporation_through_tmc',
        TRAVEL_AGENCY_BUSINESS_FOCUS: 'travel_agency_business_focus',
        TRAVEL_AGENCY_LEISURE__FOCUS: 'travel_agency_leisure_focus',
        TRAVEL_AGENCY_FREELANCERS: 'travel_agency_freelancers',
        B2C: 'b2c',
        NONE: '',
    },

    SEARCH_CONSTANTS: SEARCH,
    BOOKINGS_CONSTANTS: BOOKINGS,

    CLIENT_ROUTES: {
        SEARCH: 'search',
        RESULTS: 'results',
        HOTEL: 'hotel',
        RESERVATION: 'reservation',
        TRIP: 'trip',
        TRIPS: 'trips',
        FAQ: 'faq',
        ABOUT_US: 'about-us',
        CONTACT_US: 'contact-us',
    },

    SEARCH_FIELDS: [
        'place_id',
        'hotel_id',
        'check_in',
        'check_out',
        'guests',
        'children_ages',
        'rooms',
        // 'search_token',
        'contract_id',
        'travelers',
        'management_trip_id',
        'management_trip_name',
        'private_travel',
        'derived_from',
        // 'combtas_id',
        // 'proposal_id',
        // 'travel_booster_docket_number',
        // 'agency_client_price',
        // 'agent_pricing',
        'search_token',
        '8_rooms',
        'utm_source',
        'use_max_points',
    ],

    HOTEL_SEARCH_URL_FIELDS: [
        'place_id',
        'hotel_id',
        'check_in',
        'check_out',
        'guests',
        'children_ages',
        'rooms',
        'search_token',
        'contract_id',
        'travelers',
        'management_trip_id',
        'management_trip_name',
        'private_travel',
        'combtas_id',
        'proposal_id',
        'travel_booster_docket_number',
        'utm_source',
        'use_max_points',
    ],

    FIREBASE_STRUCTURE: {
        SEARCH: {
            COLLECTION: 'searches',
            SUB_COLLECTION: 'batches',
            FIELD: 'hotels',
        },
        RECHECK: {
            COLLECTION: 'rechecks',
            SUB_COLLECTION: 'batches',
            FIELD: 'deals',
            MESSAGE_TYPE: 'message_type',
            MESSAGE_TYPE_RECHECK: 'message_type_recheck',
            MESSAGE_TYPE_RECHECK_COMPLETED: 'message_type_recheck_completed',
        },
    },

    API_SERVICES: {
        OPS: 'ops',
        HOTELS: 'hotels',
        PARTNERS: 'partners',
    },

    ERROR_MESSAGES: {
        KEY_NOT_FOUND: 'Key not found',
    },

    ERROR_LOYALTY_POINTS: {
        NONE: 'none',
        NOT_ENABLED: 'not enabled',
        LOYALTY_NOT_DEFINED: 'loyalty_not_defined',
        NO_LOYALTY_ADAPTER: 'no_loyalty_adapter',
        LOYALTY_PROGRAM_NOT_ACTIVE: 'loyalty_program_not_active',
        CHARGE_WITH_CLUB_POINTS_NOT_ALLOWED: 'charge_with_club_points_not_allowed',
        INSUFFICIENT_POINTS: 'insufficient_points', // also change constant PAYMENT_CREDIT_CARD_ERROR_CODES.INSUFFICIENT_POINTS_ERROR
        ERROR_RETRIEVING: 'error_retrieving',
        INVALID_MAX_CAP: 'invalid_max_cap',
        NEGATIVE_POINTS: 'negative_points',
        CAP_OVERFLOW: 'cap_overflow',
        WRONG_PAYMENT_TYPE: 'wrong_payment_type',
        OTHER: 'other',
    },

    PAYMENT_TYPE: {
        NA: 'not_exists',
        COMPANY_POLICY: 'company_policy',
        CREDIT_CARD: 'credit_card', // credit card used by organically in our system
        CREDIT_CARD_DIRECT: 'credit_card_direct', // credit card used as an external system payment
        PAY_AT_HOTEL: 'pay_at_hotel',
        POINTS_ONLY: 'points_only', // Edge case where user is paying the whole amount using his points. No invoice in this case.
        GCASH_APP: 'gcash_app',
        HT_ZONE: 'ht_zone',
        CREDIT2000: 'credit2000',
        PAY_LATER: 'pay_later', // pay_later flow - cancel free cancellation reservations before it becomes non-refundable
        BNPL: 'bnpl',
        BANK_TRANSFER: 'bank_transfer',
        // TODO! Do we need this?
        EXPEDIA_MERCHANT_OF_RECORD: 'expedia_merchant_of_record', // Expedia merchant of record
        PCI_BOOKING_CREDIT_CARD: 'pci_booking_credit_card', // External API direct credit card payment with credit card through PCI booking
        // BARTER : 'barter' // inside joke :)
        // Other: payments types: possible recurring payment, cash, ...
    },

    PAYMENT_STATUS: {
        // if you update this, update the model ...
        NA: 'not_exists',
        INITIALIZED: 'initialized',
        J5: 'J5', // we managed to secure credit via j5
        CHARGE_LATER: 'charge_later', // We will use a token to charge later on. But action isn't J5 performed
        // Pay_later is just a payment_type pay_later with status initialized
        POSTPONED: 'postponed', // an iska dehuya
        PENDING_MANUAL_BILLING: 'pending_manual_billing', // postponed deals that will be billed manually
        BILLED_IN_PROCESS: 'billed_in_process', // Intermediatery step. We got the money but billing process might fail later on (e.g. charge points). Needed so poller will continue
        BILLED: 'billed', // represents a payment we got (credit card we actually billed), company policy & pay at hotel
        CANCELLED: 'cancelled',
        ERROR: 'error', // an irrecoverable error occurred
        TOKENIZED_WITHOUT_BILLING: 'tokenized_without_billing', // We got a tokenized of credit card but haven't billed yet
        TOKENIZED_WITHOUT_BILLING_WITH_PAYMENT_SESSION: 'tokenized_without_billing_with_payment_session', // We got a tokenized of credit card haven't billed yet and started payment session protocol
        TOKENIZED_WITH_BILLING: 'tokenized_without_billing_with_payment_session', // We got a tokenized of credit card haven't billed yet and started payment session protocol
        BNPL_PENDING: 'bnpl_pending',
        BNPL_RETRY_SCHEDULED: 'bnpl_retry_scheduled',
    },

    BANK_TRANSFER_REQUEST_STATUS: {
        SUBMITTED: 'submitted', // Pending review — agent submitted proof of payment, awaiting Finance
        NEEDS_CORRECTION: 'needs_correction', // Finance flagged an issue, awaiting agent resubmission
        CANCELLED_PENDING_REVIEW: 'cancelled_pending_review', // Zendesk-driven cancellation initiated, awaiting Finance
        CANCELLED: 'cancelled', // Zendesk-driven cancellation confirmed by Finance
        PAID: 'paid', // Finance confirmed payment received
    },

    BANK_TRANSFER_REQUEST_RESERVATION_STATUS: {
        ACTIVE: 'active', // this covered reservation is still part of the request
        CANCELLED: 'cancelled', // this covered reservation was cancelled independently; does not affect siblings
    },

    // BNPL cancellation_reason enum — mirrored on the Payment schema
    // (packages/mongodb/lib/model/payment.js, `bnpl.cancellation_reason`).
    BNPL_CANCELLATION_REASON: {
        TRAVELER_REQUEST: 'traveler_request',
        PAYMENT_FAILED_3X: 'payment_failed_3x',
        EXPIRED: 'expired',
    },

    // Minimum number of completed BNPL charge attempts required before the
    // booking-details API surfaces `bnpl_self_service_eligible: true` (so the
    // traveler can hit the Pay Now CTA). Shared between the api-handlers
    // booking-details annotation and the transformer payload annotation —
    // do not duplicate this literal in either consumer.
    BNPL_SELF_SERVICE_MIN_ATTEMPTS: 1,

    // Hours to wait before retrying a failed BNPL charge attempt.
    // Shared between the payments scheduler and the reminder-email template
    // builder — do not duplicate this literal in either consumer.
    BNPL_RETRY_DELAY_HOURS: 24,

    PAYMENT_CREDIT_CARD_ERROR_CODES: {
        NA: 'not_exists',
        NO_RESERVATION: 'missing_reservation',
        RESERVATION_NOT_APPROVED: 'reservation_not_approved',
        NO_PAYMENT_METHOD: 'missing_payment_method',
        MISSING_DATA: 'missing_data',
        COMMUNICATION_ERROR: 'communication_error',
        CREDIT_CARD_NOT_ACCEPTED_ERROR: 'credit_card_not_accepted_error',
        POLL_LATER_SUPPLIER_ERROR: 'poll_late_supplier_error',
        CREDIT_CARD_NOT_SUPPORTED_LOYALTY_CARD: 'credit_card_not_supported_loyalty_card',
        CHARGE_LOYALTY_POINTS_FAILED: 'charge_loyalty_points_failed',
        UNSPECIFIED_ERROR: 'unspecified_error', // Some generic catch all. There was an error
        VIRTUAL_BANK_CHARGE_ERROR: 'virtual_bank_charge_error',
        INSUFFICIENT_POINTS_ERROR: 'insufficient_points', // also change constant ERROR_LOYALTY_POINTS.INSUFFICIENT_POINTS
        GCASH_PAYMENT_ERROR: 'gcash_payment_error',
    },

    CREDIT_CARD_CUSTOMER_TYPE: {
        // Differentiate between 'israeli' 'poalim' or world card by terminal
        NONE: 'none', // Not a credit card
        POALIM_WONDER: 'wonder', // poalim Loyalty
        ISRAEL: 'israel',
        WORLD: 'world', // not creditguard
        HT_ZONE: 'ht-zone',
        CREDIT2000: 'credit2000',
    },

    WEIGHTS: {
        DIFF_PER: 'diff_per',
        LEISURE_SCORE: 'leisure_score',
        CHEAPEST_SUPPLIER_FACTOR: 'cheapest_supplier_factor',
        REVIEW: 'review',
        STARS: 'stars',
    },

    LOYALTY_POINTS_PROVIDER: {
        DEPRECATED_NO_PROVIDER: 'N/A', // no loyalty program defined
        NO_PROVIDER: 'none', // no loyalty program defined
        ARBITRIP: 'arbitrip', // arbitrip defined points
        WONDER: 'wonder', // wonder loyalty program
        ELAL: 'elal', // ELAL loyalty program
    },

    LOYALTY_POINTS_STATUS: {
        INITIALIZED: 'initialized',
        CHARGED: 'charged', // we called charge on these points and it succeeded
        CHARGED_ERROR: 'charged_error', // we got an error when charging
        REFUNDED: 'refunded', // we callred refund for these points and succeeded
        REFUNDED_ERROR: 'refunded_error', // got an error when trying to refund these points
    },

    LOYALTY_POINTS_UNLIMITED_MAX_CAP: -1,

    COUPONS_PROVIDER: {
        NO_PROVIDER: 'none', // no coupons provider defined
        ARBITRIP_USD: 'arbitrip_usd', // arbitrip USD coupons provider (powered by voucherify)
        ARBITRIP_ILS: 'arbitrip_ils', // arbitrip ILS coupons provider (powered by voucherify)
        ELAL: 'elal', // elal coupons provider (powered by voucherify)
        WONDER_MARCH_2026: 'wonder_march_2026', // wonder march 2026 campaign
    },

    CSV_EXPORT_TYPES: {
        CSV: 'csv',
        PRIORITY: 'priority',
        XLSX: 'xlsx',
    },

    MATRICS_MAGIC_NUMBER_1: 22,
    MATRICS_MAGIC_NUMBER_2: 32,
    MATRICS_MAGIC_NUMBER_3: 42,

    SPECIAL_REQUEST_SUGGESTIONS: {
        ARRIVING_LATE: {
            buttonText: 'Arriving Late',
            dialogText: 'SpecialRequestsList.SelectEstimatedTimeOfArrival',
            dialogTextTranslationKey: 'SelectYourEstimatedTimeOfArrival',
            selectPlaceHolder: 'SpecialRequestsList.SelectTime',
            options: [
                {
                    key: '1',
                    textValue: '20:00-00:00',
                },
                {
                    key: '2',
                    textValue: '00:00-03:00',
                    addNextDate: true,
                },
                {
                    key: '3',
                    textValue: '03:00-06:00',
                    addNextDate: true,
                },
                {
                    key: '4',
                    textValue: '06:00-12:00',
                    addNextDate: true,
                },
            ],
        },
    },

    ICOUNT_ACTIONS: {
        NON: 'NON', // Don't produce ICount document
        INVOICE_ONLY: 'INVOICE_ONLY', // Produce invoice only
        INVOICE_RECEIPT: 'INVOICE_RECEIPT', // Produce invoice & recipet
    },

    PRICE_SOURCE: {
        SELL_PRICE: 'SELL_PRICE', // Sell price
        CLIENT_PRICE: 'CLIENT_PRICE', // Client price
    },

    PAYMENT_METHOD: {
        CREDIT_CARD_LINK: 'CREDIT_CARD_LINK', // Credit card link payment
        BANK_TRANSFER: 'BANK_TRANSFER', // Bank transfer payment
    },

    /** CreditGuard iframe payment URL validity in seconds (used by backend when creating payment and by desktop when showing expiry dialog). */
    CREDIT_GUARD_URL_VALIDITY_SECONDS: 600,
};
